import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';

/**
 * 현장 › TBM · 시정조치 — 협력사 포털에서 쓰인 기록을 읽기만 한다(백엔드 SafeSiteController · DOC-135).
 * 모양은 포털 응답(ExternalPortalDtos.TbmView · ExternalSafeQualityDtos.SafeInspectionView) 그대로다.
 */

export type SiteTbm = {
  id: string;
  siteId: string;
  tbmDate: string;
  workSummary: string | null;
  hazards: string | null;
  requiredCount: number;
  signedCount: number;
};

/** 지적 → 조치완료(협력사 회신) → 확인완료(감리). */
export type ActionStatus = '지적' | '조치완료' | '확인완료';

export type SiteAction = {
  id: string;
  finding: string;
  location: string | null;
  riskLevel: string | null;
  dueDate: string | null;
  status: ActionStatus;
  actionNote: string | null;
  actedOn: string | null;
  confirmedBy: string | null;
  confirmedOn: string | null;
};

export type SiteInspection = {
  id: string;
  siteId: string;
  roundNo: number;
  inspectedOn: string;
  inspectionKind: string;
  inspector: string | null;
  actions: SiteAction[];
};

export function useSiteTbm(siteId: string) {
  return useQuery({
    queryKey: ['safe-site', siteId, 'tbm'],
    queryFn: () => apiFetch<SiteTbm[]>(`/v1/safe/sites/${siteId}/tbm`),
  });
}

export function useSiteInspections(siteId: string) {
  return useQuery({
    queryKey: ['safe-site', siteId, 'inspections'],
    queryFn: () => apiFetch<SiteInspection[]>(`/v1/safe/sites/${siteId}/inspections`),
  });
}
